import React from "react";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import { FormControl, MenuItem, Select } from "@mui/material";

const RpmAnalyticFilter = ({ filter, setFilter }) => {
  return (
    <FormControl>
      <Select
        disableUnderline
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        IconComponent={KeyboardArrowDownIcon}
        variant="standard"
        sx={{
          ".MuiSelect-standard": {
            background: "transparent",
            marginRight: "10px",
          },
          ".MuiSelect-select": {
            color: "#94BA33",
            fontSize: "1rem",
            fontWeight: 500,
            padding: "4px 8px",
            backgroundColor: "transparent",
          },
          "&::focus": {
            background: "transparent !important",
          },
          ".MuiSelect-icon": {
            color: "#94BA33",
            fontSize: "2rem !important",
          },
        }}
      >
        <MenuItem value="last_thirty_one_days">Last 31 days</MenuItem>
        <MenuItem value="last_year">Last Year</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RpmAnalyticFilter;
